import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DayStartEndPage } from './day-start-end.page';

const routes: Routes = [
  {
    path: '',
    component: DayStartEndPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DayStartEndPageRoutingModule {}
